import React from "react";
import useArmyBuilder from "./hooks/useArmyBuilder";
import Header from "./components/Header";
import Banner from "./components/Banner";
import Catalogue from "./components/Catalogue";
import Roster from "./components/Roster";
import AuthScreen from "./components/AuthScreen";
import { useAuth } from "./context/AuthContext";

function App() {
  const { user, loading, logout } = useAuth();
  const b = useArmyBuilder(user);

  if (loading) {
    return <div className="auth-loading" data-testid="auth-loading">Loading…</div>;
  }
  if (!user) {
    return <AuthScreen />;
  }

  return (
    <>
      <div className="app-shell">
        <Header
          sources={b.sources}
          selectedFactionId={b.selectedFactionId}
          onFactionChange={b.onFactionChange}
          pointsMode={b.pointsMode}
          setPointsMode={b.setPointsMode}
          customLimit={b.customLimit}
          setCustomLimit={b.setCustomLimit}
          totals={b.totals}
          limit={b.limit}
          saveRoster={b.saveRoster}
          loadRosterFromFile={b.loadRosterFromFile}
          exportPdf={b.exportPdf}
          clearRoster={b.clearRoster}
          user={user}
          logout={logout}
        />
        <div className="layout">
          <Catalogue
            faction={b.faction}
            factionMeta={b.factionMeta}
            filterCategory={b.filterCategory}
            setFilterCategory={b.setFilterCategory}
            searchTerm={b.searchTerm}
            setSearchTerm={b.setSearchTerm}
            currentQtyOf={b.currentQtyOf}
            addUnit={b.addUnit}
            showReinforcements={b.showReinforcements}
            roster={b.roster}
            unlockedUnits={b.unlockedUnits}
          />
          <Roster
            faction={b.faction}
            roster={b.roster}
            totals={b.totals}
            limit={b.limit}
            changeQty={b.changeQty}
            removeUnit={b.removeUnit}
            moveUnit={b.moveUnit}
            toggleGroupItem={b.toggleGroupItem}
            showReinforcements={b.showReinforcements}
            toggleReinforcements={b.toggleReinforcements}
          />
        </div>
      </div>
      <Banner banner={b.banner} />
    </>
  );
}

export default App;
